import { create } from "zustand";
import type { NetworkRetryModalCallbacks } from "@/betby/infrastructure/ui/globalUiRuntime";

export type GlobalModalPayload =
  | {
      type: "tokenExpired";
      message: string | null;
      title: string | null;
    }
  | {
      type: "networkRetry";
      callbacks: NetworkRetryModalCallbacks | null;
    };

interface GlobalUIState {
  /** 全局同时只展示一个业务弹窗 */
  modal: GlobalModalPayload | null;

  showTokenExpiredModal: (message?: string, title?: string) => void;
  hideTokenExpiredModal: () => void;

  showNetworkRetryModal: (callbacks?: NetworkRetryModalCallbacks) => void;
  hideNetworkRetryModal: () => void;
}

export const useGlobalUIStore = create<GlobalUIState>((set) => ({
  modal: null,

  showTokenExpiredModal: (message, title) =>
    set({
      modal: {
        type: "tokenExpired",
        message: message ?? null,
        title: title ?? null,
      },
    }),

  hideTokenExpiredModal: () =>
    set((s) => (s.modal?.type === "tokenExpired" ? { modal: null } : s)),

  showNetworkRetryModal: (callbacks) =>
    set({
      modal: {
        type: "networkRetry",
        callbacks: callbacks ?? null,
      },
    }),

  hideNetworkRetryModal: () =>
    set((s) => (s.modal?.type === "networkRetry" ? { modal: null } : s)),
}));
